import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useContext } from 'react';
import { useI18n } from '../../../context/occ/hooks/use-i18n';
import { MemberJourneyListContextInstance } from '../types/context';
import { getClassModifiersForJourneyGroupType } from '../utils/get-class-modifiers-for-journey-group-type';
import { getDescriptionForJourney } from '../utils/get-description-for-journey';
import { MemberJourneyListJourneyDetails } from './journey-details';
import { MemberJourneyListJourneySummary } from './journey-summary';
import { MemberJourneyListJourneyThumbnail } from './journey-thumbnail';
const b = bemClassBuilder('v-member-journey-list-journey');
export const MemberJourneyListJourney = observer(props => {
    const i18n = useI18n();
    const { journey, journeyGroupType } = props;
    const { displayText, config } = useContext(MemberJourneyListContextInstance);
    const { filmMediaType } = config;
    return (_jsxs("div", Object.assign({ className: b.block(getClassModifiersForJourneyGroupType(journeyGroupType, filmMediaType)) }, { children: [_jsx(MemberJourneyListJourneyThumbnail, { journey: journey, journeyGroupType: journeyGroupType }), _jsx("h1", Object.assign({ className: b.element('description') }, { children: getDescriptionForJourney(journey, displayText, i18n) })), _jsx(MemberJourneyListJourneyDetails, { journey: journey, journeyGroupType: journeyGroupType }), _jsx(MemberJourneyListJourneySummary, { journey: journey, journeyGroupType: journeyGroupType })] })));
});
MemberJourneyListJourney.displayName = 'MemberJourneyListJourney';
